import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/18.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Może potrzebujecie pomocy przy podkuwaniu gęsi?"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p34,
            }}
            content={
                <div>
                    <ul>
                        <li>Może potrzebujecie pomocy przy podkuwaniu gęsi?</li>
                        <li>Nie mamy dla ciebie pracy – odpowiadają ci rozbawieni gęsiarze. – My zatrudniamy się nawzajem. Ja jego, a on mnie.</li>
                        <li>Ale w imię samopomocy – dodaje żylasty. – Damy ci trochę smoły, to swoje gęsi podkujesz i do Niemiec popędzisz.</li>
                        <li>Posmarować płetwę smołą, potem wsadzić w piasek albo plewy i hajże – dodaje drugi. – Jak się postarasz, to i do Berlina dojedziesz z tym gęsim orszakiem!</li>
                    </ul>
                    <p>
                        Dzięki tobie gęsiarze mają z kogo pożartować. Nic tu po tobie, najlepiej bawią się w swoim własnym towarzystwie. Kierujesz się do sadu Emila, w końcu po południu mieliście wrócić razem do Tarszewa.
                    </p>
                </div>
            }
        />

    );
}